<div class="pageContent">
  <div class="pageTitle tareas-titulo">
    <h2>Tareas</h2>
    <div class="tareas-cancelacion-curso" *ngIf="cancelacionEnCurso; else botonCancelarTodas" role="status" aria-live="polite">
      <i class="ms-Icon ms-Icon--Sync tareas-icono-girando" aria-hidden="true"></i>
      <span>
        Cancelando tareas en segundo plano
        <ng-container *ngIf="cancelacionEnCurso.Total">({{ cancelacionEnCurso.Procesadas }} de {{ cancelacionEnCurso.Total }})</ng-container>
      </span>
      <div class="tareas-progreso-pista tareas-progreso-pista--mini">
        <div class="tareas-progreso-barra" [style.width.%]="porcentajeCancelacion"></div>
      </div>
    </div>
    <ng-template #botonCancelarTodas>
      <button
        type="button"
        class="ms-Button tareas-btn-cancelar-todas"
        (click)="abrirCancelarTodas()"
        [disabled]="totalTareas === 0"
        [title]="totalTareas === 0 ? 'No tienes tareas pendientes' : 'Cancelar todas tus tareas pendientes'"
      >
        <span class="ms-Button-label">
          <i class="ms-Icon ms-Icon--Delete" aria-hidden="true"></i>
          Cancelar todas las tareas
        </span>
      </button>
    </ng-template>
  </div>
  <div class="ms-ProgressIndicator" id="progressContainer" style="display: none;">
    <div class="ms-ProgressIndicator-itemName">Actualizando datos...</div>
    <div class="ms-ProgressIndicator-itemProgress">
      <div class="ms-ProgressIndicator-progressTrack"></div>
      <div class="ms-ProgressIndicator-progressBar" id="progressBar"></div>
    </div>
    <div class="ms-ProgressIndicator-itemDescription">Al finalizar, la tabla se recargará</div>
  </div>
  <div class="buscar-variables-container">
    <label class="buscar-variables-label">
      <input type="checkbox" [(ngModel)]="buscarPorVariables" (change)="onBuscarPorVariablesChange()" />
      Buscar por variables
    </label>
  </div>
  <app-data-table *ngIf="tableVisible" tableId="datatableTareas" [serverSide]="true" [serverData]="getDataTableTareas" [columns]="columnas" (loadedGrid)="gridLoaded($event)" (custom)="customClick($event)" [buttonsOptions]="dtOptButtons"></app-data-table>
  <div class="docs-DialogExample-lgHeader">
    <div class="ms-Dialog ms-Dialog--lgHeader cancel-observation" appPreventOutsideClick>
      <div id="dialogCreateEdit" class="ms-Dialog-title">Cancelar ejecución proceso</div>
      <form [formGroup]="cancelProcessForm" (ngSubmit)="enviarAccionProceso()" name="cancelProcessForm">
        <div class="ms-Dialog-content">
          <app-text-area [frm]="cancelProcessForm" formControlName="Observacion" [readonly]="viewObs" [required]="true" label="Observaciones" rows="3"></app-text-area>
        </div>
        <div *ngIf="viewObs" style="margin-top: 24px;">
          <app-button buttonClass="ms-Button ms-Dialog-action" buttonId="btnClose" (buttonClick)="closeCancelModal()" label="Aceptar"></app-button>
        </div>
        <div *ngIf="!viewObs">
          <app-form-buttons 
          [botonProcesando]="botonProcesando"
          buttonCancelId="btnCancel"
          labelCancel="Cancelar"
          buttonSaveId="btnCreateEdit"
          labelSave="Guardar"
          labelLoading="Cargando" 
          [frm]="cancelProcessForm"
          (cancel)="clearCancelForm()">
          </app-form-buttons>
        </div>
      </form>
    </div>
  </div>

  <div class="docs-DialogExample-lgHeader">
    <div class="ms-Dialog ms-Dialog--lgHeader cancelar-todas-dialog" appPreventOutsideClick>
      <div class="ms-Dialog-title tareas-dialog-titulo-peligro">Cancelar todas las tareas</div>

      <!-- Paso 1: confirmación -->
      <form *ngIf="!cancelacionEnCurso" [formGroup]="cancelarTodasForm" (ngSubmit)="confirmarCancelarTodas()">
        <div class="ms-Dialog-content">
          <div class="tareas-alerta" role="alert">
            <i class="ms-Icon ms-Icon--Warning" aria-hidden="true"></i>
            <div>
              <p class="tareas-alerta-titulo">
                Se cancelarán todas tus tareas pendientes<ng-container *ngIf="totalTareas"> ({{ totalTareas }})</ng-container>.
              </p>
              <p>También se cancelarán los procesos a los que pertenecen. Esta acción no se puede deshacer.</p>
            </div>
          </div>

          <app-text-area [frm]="cancelarTodasForm" formControlName="Observacion" [required]="true" [max]="1000" label="Observaciones" rows="3"></app-text-area>

          <label class="tareas-confirmacion">
            <input type="checkbox" formControlName="Confirmado" />
            Entiendo que se cancelarán todas mis tareas pendientes y que no se puede deshacer.
          </label>
        </div>
        <div class="ms-Dialog-actions tareas-dialog-acciones">
          <button type="button" class="ms-Button" (click)="cerrarCancelarTodas()" [disabled]="enviandoCancelarTodas">
            <span class="ms-Button-label">Volver</span>
          </button>
          <button type="submit" class="ms-Button tareas-btn-peligro" [disabled]="cancelarTodasForm.invalid || enviandoCancelarTodas">
            <span class="ms-Button-label">{{ enviandoCancelarTodas ? 'Iniciando…' : 'Cancelar todas las tareas' }}</span>
          </button>
        </div>
      </form>

      <!-- Paso 2: el servidor procesa en segundo plano -->
      <ng-container *ngIf="cancelacionEnCurso">
        <div class="ms-Dialog-content">
          <div class="tareas-segundo-plano">
            <i class="ms-Icon ms-Icon--Sync tareas-icono-girando" aria-hidden="true"></i>
            <div>
              <p class="tareas-alerta-titulo">La cancelación se está procesando en segundo plano.</p>
              <p>Puedes cerrar esta ventana o salir de la página: el servidor seguirá cancelando las tareas y aquí verás el resultado al terminar.</p>
            </div>
          </div>
          <div class="tareas-progreso" role="status" aria-live="polite">
            <div class="tareas-progreso-texto">
              {{ cancelacionEnCurso.Estado === 'EnCola' ? 'En cola…' : 'Cancelando ' + cancelacionEnCurso.Procesadas + ' de ' + cancelacionEnCurso.Total + '…' }}
            </div>
            <div class="tareas-progreso-pista">
              <div class="tareas-progreso-barra" [style.width.%]="porcentajeCancelacion"></div>
            </div>
          </div>
        </div>
        <div class="ms-Dialog-actions tareas-dialog-acciones">
          <button type="button" class="ms-Button" (click)="cerrarCancelarTodas()">
            <span class="ms-Button-label">Cerrar y seguir trabajando</span>
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<app-modal-notify #crearModal></app-modal-notify>
